import React from "react";
import getTexts from "../../../services/langTexts";
import { css } from "glamor";
import Selector from "./Selector";

export default class Councils extends React.Component {
  state = {
    social_service: {},
    social_service_year: new Date().getFullYear(),
    isActive: false,
    displayReports: false,
  };

  onActiveSelector = () =>
    this.setState((prevState) => ({ isActive: !prevState.isActive }));

  setYear = (social_service_year) =>
    this.setState({ social_service_year, isActive: false });

  componentDidMount() {
    const items = this.props.councilsJSON["servicio-social"] ?? [];
    if (items.length > 0) {
      let year = 0,
        social_service_items = {},
        social_service = items
          .filter((council) => council.type === "social_service")
          .sort((a, b) => a.year - b.year);
      year = social_service[social_service.length - 1].year;
      for (let index = 0; index < social_service.length; index++)
        social_service_items[social_service[index].year] = {
          ...social_service[index],
        };
      this.setState({
        social_service: social_service_items,
        social_service_year: year,
      });
    }
  }

  render() {
    let { appState, councilsJSON, fullDescription, reports } = this.props,
      { social_service, social_service_year, isActive } = this.state,
      years = Object.keys(social_service).filter(
        (year) => Number(year) !== Number(social_service_year)
      ),
      texts = getTexts("about-screen", appState.lang),
      itemHover = css({
        ":hover": { background: appState.colorTheme.secondary },
      });

    const consejo = (councilsJSON["consejo-artistas"] ?? [])[0];

    const consejo2 = null;

    const consejoAsesores = (councilsJSON["consejo-asesores"] ?? [])[0];

    const consejoDirectores = (councilsJSON["consejo-directivo"] ?? [])[0];

    const mecenas = (councilsJSON["mecenas"] ?? [])[0];

    const amigos = (councilsJSON["amigos"] ?? [])[0];

    const equipo = (councilsJSON["equipo"] ?? [])[0];

    const patronos = (councilsJSON["patronos"] ?? [])[0];

    const apoyosInstitucionales = (councilsJSON["apoyos-inst"] ?? [])[0];

    const equipoDocente = (councilsJSON["equipo-docente"] ?? [])[0];

    const amigosInternacionales = (councilsJSON["amigos-inter"] ?? [])[0];

    const consejoSummer = (councilsJSON["consejo-summer"] ?? [])[0];

    if (appState.item === 6)
      return (
        <div className="column">
          <div className="column council-block no-top">
            <h2>{texts.council.toUpperCase()}</h2>
            <div className="block-container">
              {consejo && (
                <div
                  className=" council-container no-left"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{consejo.council_title} </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: consejo.council_text,
                    }}
                  />
                </div>
              )}
              {consejo2 && (
                <div
                  className=" council-container"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{consejo.council_title} </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        typeof consejo2.council_text === "string"
                          ? consejo2.council_text.replace(/style="[^"]*"/g, "")
                          : consejo2.council_text,
                    }}
                  />
                </div>
              )}
              {consejoAsesores && (
                <div
                  className=" council-container no-right"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{consejoAsesores.council_title} </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: consejoAsesores.council_text,
                    }}
                  />
                </div>
              )}
              {consejoDirectores && (
                <div
                  className=" council-container no-right"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{consejoDirectores.council_title} </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        typeof consejoDirectores.council_text === "string"
                          ? consejoDirectores.council_text.replace(
                              /style="[^"]*"/g,
                              ""
                            )
                          : consejoDirectores.council_text,
                    }}
                  />
                </div>
              )}
              {consejoSummer && (
                <div
                  className=" council-container no-right"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{consejoSummer.council_title} </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        typeof consejoSummer.council_text === "string"
                          ? consejoSummer.council_text.replace(
                              /style="[^"]*"/g,
                              ""
                            )
                          : consejoSummer.council_text,
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="column council-block no-top" style={{ padding: 0 }}>
            <div className="row">
              <div className="column council-block no-top">
                <h2>{texts.support.toUpperCase()}</h2>
                <div className="block-container">
                  {patronos && (
                    <div
                      className=" council-container no-left"
                      style={{ maxHeight: appState.itemSize * 3 }}
                    >
                      <h3>{patronos.council_title} </h3>
                      <div
                        className=""
                        dangerouslySetInnerHTML={{
                          __html: patronos.council_text,
                        }}
                      />
                      {mecenas && (
                        <>
                          <h3 className="margin-top">
                            {mecenas.council_title}
                          </h3>
                          <div
                            className=""
                            dangerouslySetInnerHTML={{
                              __html: mecenas.council_text,
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                  {amigosInternacionales && (
                    <div
                      className=" council-container"
                      style={{ maxHeight: appState.itemSize * 3 }}
                    >
                      <h3>{amigosInternacionales.council_title} </h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            typeof amigosInternacionales.council_text ===
                            "string"
                              ? amigosInternacionales.council_text.replace(
                                  /style="[^"]*"/g,
                                  ""
                                )
                              : amigosInternacionales.council_text,
                        }}
                      />
                    </div>
                  )}
                  {amigos && (
                    <div
                      className=" council-container no-right"
                      style={{ maxHeight: appState.itemSize * 3 }}
                    >
                      <h3>{amigos.council_title} </h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: amigos.council_text,
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div
                className="council-buttons-container"
                style={{ width: appState.itemSize }}
              >
                <div className="item-box" />

                {Boolean(fullDescription) &&
                  Boolean(fullDescription.download_btn) &&
                  Boolean(fullDescription.download_btn.title) && (
                    <div
                      className="item-box button reports-button"
                      style={{
                        background: appState.colorTheme.secondary,
                        height: appState.itemSize,
                        maxHeight: appState.itemSize,
                      }}
                    >
                      <h2>{fullDescription.download_btn.title}</h2>
                      <div
                        className="cursor"
                        onClick={() =>
                          this.setState((prevState) => ({
                            displayReports: !prevState.displayReports,
                          }))
                        }
                      >
                        <div className="title">
                          <p>{fullDescription.download_btn.subtitle}</p>
                          <span
                            className={`icon-search-05 bottom ${
                              this.state.displayReports ? "rotate" : ""
                            }`}
                          />
                        </div>
                        {this.state.displayReports && (
                          <Selector
                            onClick={() =>
                              this.setState({ displayReports: false })
                            }
                            items={reports}
                            style={{ background: appState.colorTheme.level1 }}
                          />
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>

          <div className="column no-left no-right" style={{ height: "50%" }}>
            {apoyosInstitucionales && (
              <div className="column council-block no-top">
                <h3 className="margin-top">
                  {apoyosInstitucionales.council_title}
                </h3>
                <div
                  className="row no-top no-bottom council-logos"
                  dangerouslySetInnerHTML={{
                    __html: apoyosInstitucionales.council_text,
                  }}
                />
              </div>
            )}
          </div>

          <div className="column council-block no-top">
            <h2>{texts.team.toUpperCase()}</h2>
            <div className="block-container">
              {equipoDocente && (
                <div
                  className=" council-container no-left"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{equipoDocente.council_title} </h3>
                  <div
                    className="padding-text"
                    dangerouslySetInnerHTML={{
                      __html: equipoDocente.council_text,
                    }}
                  />
                </div>
              )}
              {equipo && (
                <div
                  className=" council-container no-left"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{equipo.council_title} </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: equipo.council_text,
                    }}
                  />
                </div>
              )}
              <div
                className=" council-container no-left"
                style={{
                  maxHeight: appState.itemSize * 3,
                  paddingLeft: "2vw",
                  width: "33%",
                }}
              >
                {social_service[social_service_year] ? (
                  <React.Fragment>
                    <h3>{social_service[social_service_year].council_title}</h3>
                    <div style={{ position: "relative", cursor: "pointer" }}>
                      <div
                        onClick={this.onActiveSelector}
                        className="year-selector"
                      >
                        <p>{social_service_year}</p>
                        <span className="icon-search-05 top" />
                      </div>
                      {isActive ? (
                        <div
                          className="year-option-container"
                          style={{ background: appState.colorTheme.base }}
                        >
                          {years.map((year) => (
                            <p
                              {...itemHover}
                              key={year}
                              onClick={() => this.setYear(year)}
                            >
                              {year}
                            </p>
                          ))}
                        </div>
                      ) : null}
                    </div>
                    <div
                      className="padding-text"
                      dangerouslySetInnerHTML={{
                        __html:
                          social_service[social_service_year].council_text,
                      }}
                    />
                  </React.Fragment>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      );

    if (appState.item === 4)
      return (
        <div className="column">
          <div className="column council-block no-top">
            <h2>{texts.council.toUpperCase()}</h2>
            <div className="block-container">
              {consejo && (
                <div
                  className=" council-container no-left"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{consejo.council_title}</h3>
                  <div
                    dangerouslySetInnerHTML={{ __html: consejo.council_text }}
                  />
                </div>
              )}
              {consejo2 && (
                <div
                  className=" council-container"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{consejo.council_title}</h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        typeof consejo2.council_text === "string"
                          ? consejo2.council_text.replace(/style="[^"]*"/g, "")
                          : consejo2.council_text,
                    }}
                  />
                </div>
              )}
              {consejoAsesores && (
                <div
                  className=" council-container no-right"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{consejoAsesores.council_title}</h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: consejoAsesores.council_text,
                    }}
                  />
                </div>
              )}
              {consejoDirectores && (
                <div
                  className=" council-container no-right"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{consejoDirectores.council_title}</h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        typeof consejoDirectores.council_text === "string"
                          ? consejoDirectores.council_text.replace(
                              /style="[^"]*"/g,
                              ""
                            )
                          : consejoDirectores.council_text,
                    }}
                  />
                </div>
              )}
              {consejoSummer && (
                <div
                  className=" council-container no-right"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{consejoSummer.council_title}</h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        typeof consejoSummer.council_text === "string"
                          ? consejoSummer.council_text.replace(
                              /style="[^"]*"/g,
                              ""
                            )
                          : consejoSummer.council_text,
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="column council-block no-top" style={{ padding: 0 }}>
            <div className="row">
              <div className="column council-block no-top">
                <h2>{texts.support.toUpperCase()}</h2>
                <div className="block-container">
                  <div
                    className=" council-container no-left"
                    style={{ maxHeight: appState.itemSize * 3 }}
                  >
                    {patronos && (
                      <>
                        <h3>{patronos.council_title}</h3>
                        <div
                          className=""
                          dangerouslySetInnerHTML={{
                            __html: patronos.council_text,
                          }}
                        />
                      </>
                    )}
                    <div style={{ marginBottom: "1vh" }} />
                    {mecenas && (
                      <>
                        <h3>{mecenas.council_title}</h3>
                        <div
                          className=""
                          dangerouslySetInnerHTML={{
                            __html: mecenas.council_text,
                          }}
                        />
                      </>
                    )}
                  </div>
                  {amigosInternacionales && (
                    <div
                      className=" council-container"
                      style={{ maxHeight: appState.itemSize * 3 }}
                    >
                      <h3>{amigosInternacionales.council_title}</h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            typeof amigosInternacionales.council_text ===
                            "string"
                              ? amigosInternacionales.council_text.replace(
                                  /style="[^"]*"/g,
                                  ""
                                )
                              : amigosInternacionales.council_text,
                        }}
                      />
                    </div>
                  )}
                  {amigos && (
                    <div
                      className=" council-container no-right"
                      style={{ maxHeight: appState.itemSize * 3 }}
                    >
                      <h3>{amigos.council_title}</h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: amigos.council_text,
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div
                className="council-buttons-container"
                style={{ minWidth: appState.itemSize }}
              >
                <div className="item-box" />
                {Boolean(fullDescription) &&
                  Boolean(fullDescription.download_btn) &&
                  Boolean(fullDescription.download_btn.title) && (
                    <div
                      className="item-box button reports-button"
                      style={{
                        background: appState.colorTheme.secondary,
                        height: appState.itemSize,
                        maxHeight: appState.itemSize,
                      }}
                    >
                      <h2>{fullDescription.download_btn.title}</h2>
                      <div
                        className="cursor"
                        onClick={() =>
                          this.setState((prevState) => ({
                            displayReports: !prevState.displayReports,
                          }))
                        }
                      >
                        <div className="title">
                          <p>{fullDescription.download_btn.subtitle}</p>
                          <span
                            className={`icon-search-05 bottom ${
                              this.state.displayReports ? "rotate" : ""
                            }`}
                          />
                        </div>
                        {this.state.displayReports && (
                          <Selector
                            onClick={() =>
                              this.setState({ displayReports: false })
                            }
                            items={reports}
                            style={{ background: appState.colorTheme.level1 }}
                          />
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>

          <div className="column no-left no-right" style={{ height: "50%" }}>
            {apoyosInstitucionales && (
              <div className="column council-block no-top">
                <h3 className="margin-top">
                  {apoyosInstitucionales.council_title}
                </h3>
                <div
                  className="row no-top no-bottom council-logos"
                  dangerouslySetInnerHTML={{
                    __html: apoyosInstitucionales.council_text,
                  }}
                />
              </div>
            )}
          </div>
          <div className="column council-block no-top">
            <h2>{texts.team.toUpperCase()}</h2>
            <div className="block-container">
              {equipoDocente && (
                <div
                  className=" council-container no-left"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{equipoDocente.council_title}</h3>
                  <div
                    className="padding-text"
                    dangerouslySetInnerHTML={{
                      __html: equipoDocente.council_text,
                    }}
                  />
                </div>
              )}
              {equipo && (
                <div
                  className=" council-container no-left"
                  style={{ maxHeight: appState.itemSize * 3 }}
                >
                  <h3>{equipo.council_title}</h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: equipo.council_text,
                    }}
                  />
                </div>
              )}
              <div
                className=" council-container no-left"
                style={{
                  maxHeight: appState.itemSize * 3,
                  paddingLeft: "2vw",
                  width: "33%",
                }}
              >
                {social_service[social_service_year] ? (
                  <React.Fragment>
                    <h3>{social_service[social_service_year].council_title}</h3>
                    <div style={{ position: "relative", cursor: "pointer" }}>
                      <div
                        onClick={this.onActiveSelector}
                        className="year-selector"
                      >
                        <p>{social_service_year}</p>
                        <span className="icon-search-05 top" />
                      </div>
                      {isActive ? (
                        <div
                          className="year-option-container"
                          style={{ background: appState.colorTheme.base }}
                        >
                          {years.map((year) => (
                            <p key={year} onClick={() => this.setYear(year)}>
                              {year}
                            </p>
                          ))}
                        </div>
                      ) : null}
                    </div>
                    <div
                      className="padding-text"
                      dangerouslySetInnerHTML={{
                        __html:
                          social_service[social_service_year].council_text,
                      }}
                    />
                  </React.Fragment>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      );

    return (
      <div className="column">
        <div className="column council-block no-top no-bottom">
          <h2>{texts.council.toUpperCase()}</h2>
          <div className="block-container">
            {consejo && (
              <div className=" council-container no-left">
                <h3>{consejo.council_title}</h3>
                <div
                  dangerouslySetInnerHTML={{ __html: consejo.council_text }}
                />
              </div>
            )}
            {consejo2 && (
              <div className=" council-container">
                <h3 className="margin-top">{consejo.council_title}</h3>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof consejo2.council_text === "string"
                        ? consejo2.council_text.replace(/style="[^"]*"/g, "")
                        : consejo2.council_text,
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="column council-block no-top no-bottom">
          <div className="block-container">
            {consejoAsesores && (
              <div className=" council-container no-right">
                <h3>{consejoAsesores.council_title}</h3>
                <div
                  dangerouslySetInnerHTML={{
                    __html: consejoAsesores.council_text,
                  }}
                />
              </div>
            )}
            {consejoDirectores && (
              <div className=" council-container no-right">
                <h3 className="margin-top">
                  {consejoDirectores.council_title}
                </h3>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof consejoDirectores.council_text === "string"
                        ? consejoDirectores.council_text.replace(
                            /style="[^"]*"/g,
                            ""
                          )
                        : consejoDirectores.council_text,
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="column council-block no-top ">
          <div className="block-container">
            {consejoSummer && (
              <div className=" council-container no-right">
                <h3>{consejoSummer.council_title}</h3>
                <div
                  dangerouslySetInnerHTML={{
                    __html: consejoSummer.council_text,
                  }}
                />
              </div>
            )}
          </div>
        </div>

        <div className="row no-top no-bottom">
          <div className="column council-block no-top no-bottom">
            <h2>{texts.support.toUpperCase()}</h2>
            <div className="block-container">
              <div
                className=" council-container no-left"
                style={{ maxHeight: appState.itemSize * 3, width: "50%" }}
              >
                {patronos && (
                  <>
                    <h3>{patronos.council_title}</h3>
                    <div
                      className=""
                      dangerouslySetInnerHTML={{
                        __html: patronos.council_text,
                      }}
                    />
                  </>
                )}
                {mecenas && (
                  <>
                    <h3 className="margin-top">{mecenas.council_title}</h3>
                    <div
                      className=""
                      dangerouslySetInnerHTML={{
                        __html: mecenas.council_text,
                      }}
                    />
                  </>
                )}
              </div>
              {amigosInternacionales && (
                <div
                  className=" council-container"
                  style={{ maxHeight: appState.itemSize * 3, width: "50%" }}
                >
                  <h3>{amigosInternacionales.council_title}</h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        typeof amigosInternacionales.council_text === "string"
                          ? amigosInternacionales.council_text.replace(
                              /style="[^"]*"/g,
                              ""
                            )
                          : amigosInternacionales.council_text,
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className="row no-top no-bottom"
          style={{ maxHeight: appState.itemSize }}
        >
          <div
            className="column council-block no-top no-right"
            style={{ justifyContent: "flex-start", padding: "3vw" }}
          >
            {amigos && (
              <div className="block-container">
                <div className=" council-container no-right">
                  <h3>{amigos.council_title}</h3>
                  <div
                    dangerouslySetInnerHTML={{ __html: amigos.council_text }}
                  />
                </div>
              </div>
            )}
          </div>
          <div
            className="council-buttons-container"
            style={{ width: appState.itemSize }}
          >
            {Boolean(fullDescription) &&
              Boolean(fullDescription.download_btn) &&
              Boolean(fullDescription.download_btn.title) && (
                <div
                  className="item-box button reports-button"
                  style={{
                    background: appState.colorTheme.secondary,
                    height: appState.itemSize,
                    maxHeight: appState.itemSize,
                  }}
                >
                  <h2>{fullDescription.download_btn.title}</h2>
                  <div
                    className="cursor"
                    onClick={() =>
                      this.setState((prevState) => ({
                        displayReports: !prevState.displayReports,
                      }))
                    }
                  >
                    <div className="title">
                      <p>{fullDescription.download_btn.subtitle}</p>
                      <span
                        className={`icon-search-05 bottom ${
                          this.state.displayReports ? "rotate" : ""
                        }`}
                      />
                    </div>
                    {this.state.displayReports && (
                      <Selector
                        onClick={() => this.setState({ displayReports: false })}
                        items={reports}
                        style={{ background: appState.colorTheme.level1 }}
                      />
                    )}
                  </div>
                </div>
              )}
          </div>
        </div>

        <div className="column no-left no-right">
          {apoyosInstitucionales && (
            <div className="column council-block no-top">
              <h3 className="margin-top">
                {apoyosInstitucionales.council_title}
              </h3>
              <div
                className="row no-top no-bottom council-logos"
                style={{ flexWrap: "wrap" }}
                dangerouslySetInnerHTML={{
                  __html: apoyosInstitucionales.council_text,
                }}
              />
            </div>
          )}
        </div>

        <div className="column council-block no-top no-bottom">
          <h2>{texts.team.toUpperCase()}</h2>
          <div className="block-container">
            <div
              className=" council-container no-left "
              style={{ width: "50%" }}
            >
              {equipoDocente && (
                <React.Fragment>
                  <h3>{equipoDocente.council_title}</h3>
                  <div
                    className="padding-text"
                    dangerouslySetInnerHTML={{
                      __html: equipoDocente.council_text,
                    }}
                  />
                </React.Fragment>
              )}

              {social_service[social_service_year] ? (
                <React.Fragment>
                  <h3>{social_service[social_service_year].council_title}</h3>
                  <div style={{ position: "relative", cursor: "pointer" }}>
                    <div
                      onClick={this.onActiveSelector}
                      className="year-selector"
                    >
                      <p>{social_service_year}</p>
                      <span className="icon-search-05 top" />
                    </div>
                    {isActive ? (
                      <div
                        className="year-option-container"
                        style={{ background: appState.colorTheme.base }}
                      >
                        {years.map((year) => (
                          <p key={year} onClick={() => this.setYear(year)}>
                            {year}
                          </p>
                        ))}
                      </div>
                    ) : null}
                  </div>
                  <div
                    className="padding-text"
                    dangerouslySetInnerHTML={{
                      __html: social_service[social_service_year].council_text,
                    }}
                  />
                </React.Fragment>
              ) : null}
            </div>
            {equipo && (
              <div
                className=" council-container no-left"
                style={{ maxHeight: appState.itemSize * 3, width: "50%" }}
              >
                <h3>{equipo.council_title}</h3>
                <div
                  dangerouslySetInnerHTML={{ __html: equipo.council_text }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
